import React, { useState, useEffect } from "react";
import "./dashboardLayout.css";
import { connect } from "react-redux";
import Navbar from "../navbar";
import FooterComponent from "../footer";
import HeaderComponent from "../header";
import { Button, Layout } from "antd";
import klogo from "../../assets/images/fav-ico.png";
import logo from "../../assets/images/kravemart-logo-black.png";
import { Outlet } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as AuthActions from "../../redux/actions/auth.actions";

const { Sider, Content } = Layout;

const DashboardLayout = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  
  useEffect(() => {
    if(props.navbar_collapsed != null) setCollapsed(props.navbar_collapsed);
  }, [props.navbar_collapsed]);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    props.AuthActions.navbarCollapsedAction(!collapsed);
  };

  return (
    <div>
      <Layout>
        <Sider
          className="rocky-sidebar"
          trigger={null}
          collapsible
          collapsed={collapsed}
        >
          <Button className="btn-collapsed" onClick={toggleCollapsed}>
            {collapsed ? (
              <img src={klogo} alt="logo" width="75%" />
            ) : (
              <img src={logo} alt="logo" width="60%" />
            )}
          </Button>
          <Navbar />
          <FooterComponent />
        </Sider>
        <Layout className="rockey-page-content">
          <HeaderComponent />
          <Content className="page content">
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    navbar_collapsed: state.authReducer.navbar_collapsed,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AuthActions: bindActionCreators(AuthActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardLayout);
